<template>
  <div>

   <b-nav tabs align="center">
     <b-nav-item v-if="hasRoles(['Admin','Disponent','Cutter'])" to="/anfragen">
       <span class="icon-profile cutterkollegen-lightbulb"></span>
        <div class="small-font">Anfragen</div>
     </b-nav-item>
     <b-nav-item v-if="hasRoles(['Admin','Disponent','Cutter','Kunde'])" to="/projekte">
       <span class="icon-profile cutterkollegen-check-circle"></span>
        <div class="small-font">Projekte</div>
     </b-nav-item>
     <b-nav-item v-if="hasRoles(['Admin','Cutter'])"  to="/archiv">
       <span class="icon-profile"> <i class="bi bi-archive-fill"></i></span>
        <div class="small-font">Archiv</div>
     </b-nav-item>
     <b-nav-item v-if="hasRoles(['Admin'])"  to="/BenutzerList">
       <span class="icon-profile"> <i class="bi bi-people-fill"></i></span>
        <div class="small-font">Benutzer</div>
     </b-nav-item>
     <b-nav-item v-if="hasRoles(['Admin'])"  to="/stammdaten">
       <span class="icon-profile"> <i class="bi bi-gear-fill"></i></span>
        <div class="small-font">Daten</div>
     </b-nav-item>
     <b-nav-item v-if="user" to="/profil">
       <span class="icon-profile cutterkollegen-user-circle"></span>
        <div class="small-font">Profil</div>
     </b-nav-item>
  </b-nav>

  </div>
</template>
<script>
import utils from '@/utilities'

export default {
  name: 'TopMenu',
  props: ['user'],
  methods: {
    hasRoles (roles) {
      // make sure to take the roles from the token, as normal user doent have the roles in der user object
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), roles)
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/partials/TopMenu.vue